<div
	class="slide slide--influencers-voice-share"
	[style.--slide-accent-color]="titleColor"
>
	<div class="slide__header">
		<div class="slide__content-copy">
			<typography variant="h/2" class="slide__title">
				<app-report-inline-text
					[text]="title"
					[field]="textFields.title"
					[editorMode]="editorMode"
				></app-report-inline-text>
			</typography>
			<div class="slide__date-row">
				<app-icon type="svg" [size]="14">calendar_today</app-icon>
				<typography variant="p/xs_regular" class="slide__date-text">
					{{ dateLabel }}
				</typography>
			</div>
			<typography variant="p/sm_regular" class="slide__summary">
				<app-report-inline-text
					[text]="summaryText"
					[field]="textFields.body"
					[editorMode]="editorMode"
				></app-report-inline-text>
			</typography>
		</div>

		<div class="slide__kpi" *ngIf="!isEmpty && topShareValue">
			<typography variant="h/1" class="slide__kpi-value">
				{{ topShareValue }}
			</typography>
			<div class="slide__kpi-label-row">
				<span class="slide__kpi-dot"></span>
				<typography variant="p/sm_regular" class="slide__kpi-label">
					{{ topShareLabel }}
				</typography>
			</div>
		</div>
	</div>

	<div class="slide__body" *ngIf="!isEmpty">
		<div class="slide__panel slide__panel--table">
			<typography variant="p/base_medium" class="slide__panel-title">
				Voice share leaderboard
			</typography>
			<div class="slide__table">
				<div class="slide__table-head">
					<span class="slide__th slide__th--rank">#</span>
					<span class="slide__th">Influencer</span>
					<span class="slide__th">Channel</span>
					<span class="slide__th slide__th--right">Share</span>
					<span class="slide__th slide__th--right">Mentions</span>
				</div>
				<div
					class="slide__table-row"
					*ngFor="let row of rows; trackBy: trackByRow"
				>
					<span class="slide__td slide__td--rank">
						{{ row.rank }}
					</span>
					<div class="slide__td slide__td--influencer">
						<span
							class="slide__avatar"
							[style.background]="row.color"
						>
							{{ row.initial }}
						</span>
						<span class="slide__handle">{{ row.handle }}</span>
					</div>
					<span class="slide__td slide__td--channel">
						{{ row.channel }}
					</span>
					<span class="slide__td slide__td--right slide__td--share">
						{{ row.sharePct }}
					</span>
					<span
						class="slide__td slide__td--right slide__td--mentions"
					>
						{{ row.mentions | number }}
					</span>
				</div>
			</div>
		</div>

		<div class="slide__panel slide__panel--chart">
			<typography variant="p/base_medium" class="slide__panel-title">
				Voice share distribution
			</typography>
			<div class="slide__bars slide__chart-host">
				<ng-container *ngIf="!chartSwitch.block">
					<div
						class="slide__bar-row"
						*ngFor="let row of rows; trackBy: trackByRow"
					>
						<span class="slide__bar-label">{{ row.handle }}</span>
						<div class="slide__bar-track">
							<div
								class="slide__bar-fill"
								[style.width.%]="row.barWidthPct"
								[style.background]="row.color"
							></div>
							<span class="slide__bar-value">
								{{ row.sharePct }}
							</span>
						</div>
					</div>
				</ng-container>
				<app-report-chart-switch
					[state]="chartSwitch"
					[themeColor]="themeColor"
					[editorMode]="editorMode"
					(chartTypeChange)="chartTypeChange.emit($event)"
				></app-report-chart-switch>
			</div>
		</div>
	</div>

	<app-slide-no-data *ngIf="isEmpty"></app-slide-no-data>

	<div class="slide__footer">
		<app-report-slide-brand class="slide__footer-left">
			<typography variant="p/xxs_regular" class="slide__footer-copy">
				Powered by
			</typography>
			<typography variant="p/xxs_semibold" class="slide__footer-brand">
				lolly
			</typography>
		</app-report-slide-brand>
		<div class="slide__footer-tag">top influencers</div>
	</div>
</div>
